module.exports = __webpack_public_path__ + "img/pay-bac.9d31d26c.jpg";